import { CONTRIBUTOR_PUBLISH_TEXT, CONTRIBUTOR_REPUBLISH_TEXT, DFLT_PUBLISH_TEXT, SUBMISSION_PUBLISH_TEXT } from "modules/common/components/authoring/constants";
import { IContentOverview } from "modules/common/models";
import { Event } from "../../../events/models";

/**
 * Computes the name of the label for the publish button. This varies depending on
 * the state of the draft and the permissions of the user viewing the draft. 
 * @param isContributor boolean, if the current user is contributor
 * @param isSubmission boolean, if the current draft was marked as a submission
 * @param isDraftIdPresent boolean, if the current draft has an id
 * @returns string, the label for the publish button in the post creation page
 */
export const getPublishBtnName = (
    isContributor: boolean,
    isSubmission: boolean,
    isDraftIdPresent: boolean,
    ): string => {
    if (isContributor){
        return (isDraftIdPresent && isSubmission) ? CONTRIBUTOR_REPUBLISH_TEXT : CONTRIBUTOR_PUBLISH_TEXT
    } 
    else {
        return isSubmission ? SUBMISSION_PUBLISH_TEXT : DFLT_PUBLISH_TEXT;
    }
};

/**
 * Computes the publish button label for the Manage Events/Posts list "Preview"
 * modal, where the primary action must be scoped to the individual item's own
 * status rather than the generic contributor/submission rules used in-editor.
 * Per BUG-22601/BUG-22547 (posts) and FEATURE-23445 (events): no publish action
 * from the list preview except "Approve & Publish" for non-contributors
 * reviewing a submission. Drafts (including a contributor's own) get no
 * action here (edit only), published items get none (they get "open in
 * portal" instead). Callers compute `isSubmissionAwaitingReview` themselves
 * since posts and events encode submission state differently.
 */
export const getListPreviewPublishLabel = (isContributor: boolean, isSubmissionAwaitingReview: boolean): string | undefined => {
    return !isContributor && isSubmissionAwaitingReview
        ? SUBMISSION_PUBLISH_TEXT
        : undefined;
};

export const asContentOverview = (event: Event, preferredLCID: string): IContentOverview => {
    return {
        author: { name: event.author, email: event.authorEmail ?? "", avatar: { color: "#2196f3" } },
        imageUrl: event.image?.url ?? "",
        datePublished: event.publishTime ?? "",
        preferredLCID: preferredLCID,
        status: event.status ?? "",
        id: event.id,
        translatedContent: event.translatedContent,
        attachedContent: event.attachedContent,
        fileAttachments: event.fileAttachments,
        bannerColor: event.bannerColor ?? "",
        commentingEnabled: event.commentingEnabled,
        isSubmission: event.isSubmission
    } as IContentOverview;
}
